<template> 
<transition name="modal">
 <div id="closepopup" class="modal modal-mask" style="display: block" @click="close()">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <slot name="header"></slot>
      </div> -->
      
      <div class="modal-body">
        <slot name="body"></slot>
      </div>
      
      <!-- <div class="modal-footer">
        <slot name="footer"></slot>
      </div> -->
    </div>
  </div>
</div>
</transition> 
</template>



<script>

export default {
  name: 'Modal',
  data () {
    return {
        showModal: false
    }
  },
  mounted() {
      
  },
  methods: {
      close() {
          var x = document.getElementById("closepopup");
          if (x.style.display === "none") {
              x.style.display = "block";
          } else {
              x.style.display = "none";
          }
          localStorage.setItem('popupStatus', 'seen');
          var body = document.body;
          body.style.position = "initial";
          body.style.width = "auto";
      }
  },
  computed: {
  }
}

</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-dialog {
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
}
.modal-content {
    border: none;
    box-shadow: none;
}
@media only screen and (max-width: 767px) {
   .modal-dialog {
        top: 100%;
        transform: translateY(-100%);
   }
   .modal-content {
       border-bottom-left-radius: 0;
       border-bottom-right-radius: 0;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue